// extracted by mini-css-extract-plugin
export var deliveryRow = "_on-a";
export var fixedHeight = "_on-4";
export var freightLogo = "_on-9";
export var fullWidth = "_on-3";
export var priceColumn = "_on-5";
export var radioSelected = "_on-7";
export var radioUnselected = "_on-6";
export var selectedOption = "_on-2";
export var selectedOptionContainer = "_on-1";
export var selection = "_on-0";
export var tallSkeletonText = "_on-8";